



























































import {TranslateResult} from 'vue-i18n'
import {Component, Vue } from 'vue-property-decorator'

import {namespace} from 'vuex-class'
import CommonWidgetInfobar from '@/components/common/widget/Testing.vue';
import IProduct from '@/components/icons/IProduct.vue';
import ISurvey from '@/components/icons/ISurvey.vue';
import IStandmans from '@/components/icons/IStandmans.vue';
import IShardList from '@/components/icons/IShardList.vue';
import IStatistic from '@/components/icons/IStatistic.vue';
import ISupport from '@/components/icons/ISupport.vue';
import ChangeStyle from '@/components/lfs/Style/ChangeStyle.vue';
import NameExhibition from '@/components/UI/NameExhibition.vue';
import IChecklist from "@/components/icons/IChecklist.vue";



const auth = namespace('auth')
const profile = namespace('profile')
const app = namespace('app')
const locale = namespace('locale')
const event = namespace('event')
const roistat = namespace('roistat')

interface ISidebarMenu {
  route: string
  icon: IIcon
  text: TranslateResult
  displayConditionPlan: (v: string) => {}
}

interface IIcon {
  color?: string
  component: string | object
  width?: string
  height?: string
}

@Component({
  components: {
    IChecklist,
    IStandmans,
    ChangeStyle,
    ISupport,
    IStatistic,
    IShardList,
    ISurvey,
    IProduct,
    CommonWidgetInfobar,
    NameExhibition,
  }
})
export default class EventSideBar extends Vue {
  @profile.Getter('plan') protected plan: any
  @profile.Getter('plan') protected profileStatus: any
  @event.Getter('shows') protected shows:any
  @auth.Action('logout') protected authLogout: any
  @roistat.Action('sendEvent') protected sendEvent:any
  @profile.State("userCompany") protected userCompany: any


  menu: ISidebarMenu[] = [
    {
      route: 'ContactBlock',
      icon: {
        component: 'IChecklist'
      },
      text: 'sidebar.contact',
      displayConditionPlan: (_: string) => {
        return true
      }
    },
    {
      route: 'Standmans',
      icon: {
        component: 'IStandmans',
      },
      text: 'sidebar.standmans',
      displayConditionPlan: (role: string) => {
        return role !== 'admin'
      }
    },
    {
      route: 'Surveys',
      icon: {
        component: 'ISurvey'
      },
      text: 'sidebar.survey',
      displayConditionPlan: (plan: string) => {
        return plan === 'pro'
      }
    },
    {
      route: 'SurveysDemo',
      icon: {
        component: 'ISurvey'
      },
      text: 'sidebar.survey',
      displayConditionPlan: (plan: string) => {
        return plan !== 'pro'
      }
    },
    {
      route: 'Products',
      icon: {
        component: 'IProduct',
      },
      text: 'sidebar.product',
      displayConditionPlan: (role: string) => {
        return role !== 'admin'
      }
    },
    {
      route: 'ShardList',
      icon: {
        component: 'IShardList'
      },
      text: 'sidebar.collectedData',
      displayConditionPlan: (role: string) => {
        return role !== 'admin'
      }
    },
    {
      route: 'Statistics',
      icon: {
        component: 'IStatistic',
      },
      text: 'sidebar.statistic',
      displayConditionPlan: (plan: string) => {
        return plan !== 'free'
      }
    },
    {
      route: 'Support',
      icon: {
        component: 'ISupport'
      },
      text: 'sidebar.support',
      displayConditionPlan: (role: string) => {
        return role !== 'admin'
      }
    },

  ]

  protected tryLogout() {
    this.authLogout()
      .then(() => {
        this.$router.push({name: 'Auth'})
      })
      .catch(() => {
      })
  }

  protected image: string = '/img/sidebar.jpg'
  protected sidebarOverlayGradiant: string = 'rgba(27, 27, 27, 0.74), rgba(27, 27, 27, 0.74)'

  protected responsive: boolean = false


  @app.Getter('GetShowSb') protected GetShowSb: any
  @app.Getter('GetWidth') protected GetWidth: any
  @app.Mutation('SetShowSbToggle') protected SetShowSbToggle: any
  @app.Mutation('SetShowSb') protected SetShowSb: any
  @app.Mutation('SetWidth') protected SetWidth: any

  set drawer(val: Boolean) {
    this.SetShowSbToggle(val)
  }

  get drawer() {
    return this.GetShowSb
  }

  protected onResponsiveInverted(): void {
    if (window.innerWidth > 991) {
      this.SetShowSb(true)
      this.SetWidth(window.innerWidth)
    } else {
      if (Math.abs(window.innerWidth - this.GetWidth) > 100) {

        this.SetWidth(window.innerWidth)
        this.SetShowSb(false)
      }

    }
  }

  protected mounted(): void {
    this.SetWidth(window.innerWidth)
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  }

  protected beforeDestroy(): void {
    window.removeEventListener('resize', this.onResponsiveInverted)
  }

  sendEventToRoistat(item:any) {
    let params = [
      {
        "name": "Посещение категории " + (item.route == 'Standmans' ? "“Стендисты”" :
                                          item.route == 'ProductList' ? "“Продукция”" :
                                          item.route == 'ShardList' ? "“Собранные данные”" :
                                          item.route == 'Survey' ? "“Анкета”" :
                                          item.route == 'Statistics' ? "“Статистика”" :
                                          item.route == 'Support' ? "“Техподдержка”" : ""),
        "data": {
          "company": this.userCompany.title
        }
      }
    ]
    this.sendEvent(params)
  }

//   baseColorText = '#363636'
//   changeColor(){
//     if(this.baseColorText === "grey"){
//       this.baseColorText = "red"
//     }else {
//       this.baseColorText = "grey"
//     }
//   }
//   get userStyle() {
//     return {
//       '--base-color-text': this.baseColorText
//     }
//   }
}

